module.exports = __webpack_public_path__ + "static/media/warom_ifrs.f53f00c8.png";